import { BasePlugin } from '../base'
import mdcChip from './mdc-chip.vue'
import mdcChipSet from './mdc-chip-set.vue'

export { mdcChip, mdcChipSet }

export default BasePlugin({
  mdcChip,
  mdcChipSet
})
